import React, { useMemo } from "react";
import useSeo from "../seo/useSeo";
import useJsonLd from "../seo/useJsonLd";
import FAQ from "../components/FAQ";

export default function FaqPage() {
  useSeo({
    title: "FAQ – Questions fréquentes | pdf-convert.fr",
    description:
      "Réponses sur les conversions PDF/images, la confidentialité (sans envoi), les formats supportés et la qualité.",
    canonical: "https://pdf-convert.fr/faq",
  });

  const faqItems = [
    {
      q: "Mes fichiers sont-ils envoyés sur un serveur ?",
      a: "Non. Tous les traitements (conversion PDF, images, compression) sont effectués directement dans votre navigateur. Aucun fichier n’est envoyé ni stocké sur nos serveurs.",
    },
    {
      q: "Quels formats de fichiers sont acceptés ?",
      a: "PDF pour la conversion en images. Pour les images vers PDF ou la compression : JPG, JPEG, PNG, WebP, GIF et BMP.",
    },
    {
      q: "Pourquoi y a-t-il parfois des marges blanches dans les PDF ?",
      a: "Le format A4 est conservé. Si l’image n’a pas le même ratio que le A4, des marges peuvent apparaître afin d’éviter toute déformation.",
    },
    {
      q: "Puis-je réduire la taille d’une image sans perdre de qualité ?",
      a: "Une légère perte de qualité est parfois inévitable, mais vous pouvez ajuster le niveau de compression pour trouver le meilleur compromis.",
    },
    {
      q: "Le site est-il gratuit ?",
      a: "Oui, les outils proposés sur pdf-convert.fr sont accessibles gratuitement, sans inscription.",
    },
    {
      q: "Pourquoi je ne vois pas toujours de publicités ?",
      a: "Les publicités s’affichent uniquement après acceptation des cookies. Elles peuvent aussi mettre un peu de temps à apparaître si le compte publicitaire est en cours de validation.",
    },
    {
      q: "Le site fonctionne-t-il sur mobile ?",
      a: "Oui, mais les conversions lourdes peuvent être plus lentes selon votre appareil. Sur ordinateur, c’est généralement plus rapide.",
    },
  ];

  // JSON-LD FAQPage
  const faqJsonLd = useMemo(() => {
    return {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqItems.map((it) => ({
        "@type": "Question",
        name: it.q,
        acceptedAnswer: {
          "@type": "Answer",
          text: it.a,
        },
      })),
    };
  }, [faqItems]);

  useJsonLd("faq-jsonld", faqJsonLd);

  return (
    <main style={{ maxWidth: 900, margin: "0 auto", padding: 16 }}>
      <h1>Foire aux questions (FAQ)</h1>
      <p style={{ textAlign: "center", color: "#666", marginBottom: 24 }}>
        Retrouvez ici les réponses aux questions les plus fréquentes sur nos
        outils de conversion et de compression.
      </p>

      <FAQ title="Questions fréquentes" items={faqItems} />
    </main>
  );
}
